export const FINISH_TOUR = 'FINISH_TOUR';
export const TOUR_VISIBLE = 'TOUR_VISIBLE';
export const CONTINUE_TOUR = 'CONTINUE_TOUR';
